<template>
  <div class="sp_agent_chat_header">
    <div class="sp_chat_header_avatar">
      <div>
        <img :src="avatarImageUrl" :alt="title || 'Agent Avatar'" class="sp_agent_avatar" />
      </div>
      <div class="sp_chat_header_avatar_name">
        <span class="sp_chat_header_avatar_name_text">{{ title }}</span>
      </div>
    </div>
    <div class="sp_chat_header_actions">
      <button class="sp_chat_header_btn sp_minimize_btn" @click="$emit('set-layout', LAYOUTS.INPUT)" title="Minimize">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <button v-if="!isSidebarAligned && !isTablet && !isMobile" class="sp_chat_header_btn sp_sidebar_btn" @click="$emit('set-layout', LAYOUTS.SIDEBAR)" title="Align to sidebar">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-panel-right-icon lucide-panel-right">
          <rect width="18" height="18" x="3" y="3" rx="2" />
          <path d="M15 3v18" />
        </svg>
      </button>
      <button v-if="!isFullscreen" class="sp_chat_header_btn sp_fullscreen_btn" @click="$emit('fullscreen')" title="Fullscreen">
        <svg v-if="isFullscreen" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minimize2-icon lucide-minimize-2">
          <path d="m14 10 7-7" />
          <path d="M20 10h-6V4" />
          <path d="m3 21 7-7" />
          <path d="M4 14h6v6" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-maximize2-icon lucide-maximize-2">
          <path d="M15 3h6v6" />
          <path d="m21 3-7 7" />
          <path d="m3 21 7-7" />
          <path d="M9 21H3v-6" />
        </svg>
      </button>
      <button class="sp_chat_header_btn sp_close_btn" @click="$emit('set-layout', LAYOUTS.ICON)" title="Close">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import MediaQueryMixin from "../mixins/mediaQuery.js";
import { LAYOUTS } from "../constants/layouts.js";

export default {
  name: "ChatHeaderV2",
  mixins: [MediaQueryMixin],
  props: {
    title: {
      type: String,
      default: "Chat",
    },
    subtitle: {
      type: String,
      default: "",
    },
    avatarImage: {
      type: String,
      default: "",
    },
    isSidebarAligned: {
      type: Boolean,
      default: false,
    },
    isFullscreen: {
      type: Boolean,
      default: false,
    },
    hasPlaylistItems: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { LAYOUTS };
  },
  computed: {
    avatarImageUrl() {
      return this.avatarImage || "https://embed.showpilot.com/placeholders/images/agent-avatar.png";
    },
  },
};
</script>

<style lang="scss" scoped>
.sp_agent_chat_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7ea;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
}

.sp_chat_header_avatar {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sp_agent_avatar {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
}

.sp_chat_header_avatar_name {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 2px;
  letter-spacing: -0.3px;
}

.sp_chat_header_actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sp_chat_header_btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;

  &:hover {
    background: #f2f3f5;
    color: #060e2b;
  }

  &:active {
    transform: scale(0.95);
  }

  &.active {
    background: var(--sp-chat-primary);
    color: #ffffff;

    &:hover {
      background: var(--sp-chat-primary);
    }
  }

  svg {
    width: 18px;
    height: 18px;
  }
}

.sp_close_btn:hover {
  background: #fee2e2;
  color: #dc2626;
}

@media (max-width: 560px) {
  .sp_agent_chat_header {
    padding: 12px 16px;
  }

  .sp_agent_avatar {
    width: 32px;
    height: 32px;
  }

  .sp_chat_header_btn {
    width: 28px;
    height: 28px;

    svg {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
